<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="証書情報（詳細）(old)" >

          </title-and-slot>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary" style="width: 25%;float: left;margin-left: -25px;min-width:100px;" @click="backToList" >＜　戻る</button>
            </div>
            <div class="col-xs-8">
              <div style="width:180px;float:right;font-size:12px;text-align: right;">更新日：{{registrationDate}}</div>
              <div style="width:180px;float:right;font-size:12px;text-align: right;">登録日：{{registrationDate}}</div>
            </div>
              <div class="col-xs-12">
               <div style="float:right;font-size:10px;text-align: right;color:red;">＊入力必須項目</div> 
              </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            承認状態：
            <input :disabled="readOnly" style=" border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" :value="approvalStatus" />
            状態:
            <select
            :disabled="readOnly"
            :value="Status"
            @change="Status = $event.target.value"
            style=" border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" >
             <option v-for="option in StatusOptions" :selected="option==Status" :key="option" :value="option">{{option}}</option>
            </select>
            申請No：
            <input type="button" 
            style=" border: solid #337ab7 1px;width: 140px;padding-left:4px;margin: 2px;margin-bottom: -6px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;color: #008cff;text-decoration: underline;" 
            :value="approvalHistoryTorokuNumber" 
            @click="onConfirmExecuteProcessConfirmation"
            />
          </div>
          <div class="row" style="margin-bottom:10px;">
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f" :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
              </div>
            </div>
          </div>
          </div>
            <div class="row" style="margin-bottom:10px;">
              <button
                v-show ="isAdminSavingApplication == true"
                v-if="read_only == false"
                :disabled="disableAllButtons || checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;background: #337ab7;" @click="onLocalUpSaveDevEmbedded" >上書保存</button>
              <button
                v-show ="isAdminSavingApplication == false"
                v-if="read_only == false"
                :disabled="disableAllButtons || checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;"  @click="onLocalSaveDevEmbedded" >下書保存</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #A6A6A6;" @click="btnCancel" >ｷｬﾝｾﾙ</button>
              <button v-else
                v-show="hideEditMainBtn == false"
                :disabled="disableAllButtons || disableEditMainBtn || checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;" @click="onEdit"  >編集</button>
            </div>
          <span v-show ="is_new == true">「下書保存」ボタンを押したら「ソフトウェア情報」が出ます。</span>
            <div class="row" style="margin-bottom:0px;">
              <transition name="fade">
                  <div>
                    <div :style="subTableDeviceEmbeddedInformationStyle">
            　      <h3>ソフトウェア情報</h3>
                    <sub-table-associated_device
                      v-if="showAssociatedDevice"
                      :disable_new_btn = "disableNewToSubTableBtn"
                      :disable_edit_btn = "disableEditSubTableBtn"
                      :hide_new_btn = "hideNewToSubTableBtn"
                      :hide_edit_btn = "hideEditSubTableBtn"
                      :disable_all_btn = "disableAllButtons"
                      style="margin-bottom:20px"
                      :ref_id="certificateManagementNumber"
                      :fk_id="certificateSeqId"
                      @data-saved="subTableSaved()"
                      tag_reload="reloadSubTableCertificateInformation" />
                  </div>
                </div>
              </transition>
             </div>
            <!-- Should be a component -->
            <div class="row" style="margin-bottom:20px;">
              <button :disabled="disableAllButtons || checkUserPermission(true,permissionMode.BROWSE) == false"
                      v-if="is_new == false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;background: #A6A6A6;border-color:#A6A6A6;" 
                      @click="showHistory" >更新履歴</button>
              <button v-show ="hideApplyConfirmationBtn == false"
              :disabled="disableAllButtons || checkUserPermission(true,permissionMode.EDIT) == false" @click="processApprovalApprove()"
                      class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;">確認</button>
              <button v-show ="hideApplyRejectBtn == false"
                      :disabled="disableAllButtons || checkUserPermission(true,permissionMode.EDIT) == false"
                      @click="processApprovalCancel"
                      class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">差戻</button>
               <button
                v-show ="hideApplicationBtn == false"
                :disabled="disableAllButtons || disableApplicationBtn || checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary"
                style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;" @click="onConfirmExecuteProcess" >申請</button>
               <button v-show ="hideCopyMainBtn == false"
                :disabled="disableAllButtons || checkUserPermission(true,permissionMode.ADD) == false" 
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="cloneRecord" >コピー</button>
              <!--<button :disabled="checkUserPermission(true,permissionMode.DELETE) == false" v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">新規</button>
              -->
              </div>
            </div>
        <confirmation-modal tag="confirmDeviceEmbeddedInformationUpAddCheck" @done="onDeviceEmbeddedInformationUpAddCheckConfirm" />
        <file-modal tag="showFileModal2" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddcancel" @done="processApprovalCancelBack" />
        <certificate-information-connection-application-modal tag="showBulkImportConfimationModal" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddCheck" @done="onDeviceEmbeddedInformationAddCheckConfirm" />
        <confirmation-modal tag="notificationAfterSave" @done="afterTheNotificationAfterSave" />
        <confirmation-modal tag="notificationAftercancel" @done="afterTheNotificationAftercancel" />
        <application-confirmation-modal tag="certificateApplicationConfimationModal" />
        <log-history tag="showCertificateInformationlogHistoryModal"/>
        <confirmation-modal tag="deleteCertificateInformationDetailModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import bulkImportConfirmationModal from "@/components/modals/certificate-information-connection-application-modal";
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';
import subTableAssociatedDevice from '@/components/sub_pages/associated_device';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import fileModal from "@/components/modals/file-modal";
import logHistoryModal from '@/components/modals/log-history-modal';
import constants from "@/rules/constants";

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    // 'sub-table-associated_device': subTableAssociatedDevice,
    // 'field-box': fieldBoxes,
    // "certificate-information-connection-application-modal" :bulkImportConfirmationModal,
    // 'application-confirmation-modal':applicationConfirmationModal,
    // 'file-modal':fileModal,
    // 'log-history':logHistoryModal

  },
  data() {
    return {
      // show_sub_table_associated_device: false,
      // api_name:"certificate_information",
      // row_data: [],
      // data_values: {},
      // data_values_original: {},
      // selected_row: -1,
      // last_notify_about_data_updated: 0,
      // filter_list: [],
      // filter_changed: false,
      // forceSelectOnReturn: false,
      // page_acl: acl.certificate_information_detail,
      // approval_history_id:"",
      // approval_id:null,
      // local_status:false,
      // save_edit_cliqued:false,
      // local_seq_id:-1,
      // show_associated_device:true,
      // approval_history_toroku_number:false
    };
  },
  computed: {
    // disableAllButtons(){
    //   return this.loadBy == "certificate_information_number"
    // },
    // showAssociatedDevice:{
    //   get(){
    //     return this.show_associated_device;
    //   },
    //   set(v){
    //     this.show_associated_device = v;
    //   }
    // },
    // localSeqId:{
    //   get(){
    //     return this.local_seq_id;
    //   },
    //   set(v){
    //     this.local_seq_id = v;
    //   }
    // },
    // // About to hide or show the buttons start
    // disableEditMainBtn(){ //編集 (edit main)
    //   if(this.loadBy == 'fk_id' ){
    //     return this.hideForApplicant 
    //   }
    //   return this.approvalStatus == "申請中"
    // },
    // disableNewToSubTableBtn(){// 新規 (new to sub-table)
    //   if(this.loadBy == 'fk_id' ){
    //     return this.hideForApplicant 
    //   }
    //   return this.approvalStatus == "申請中"
    // },
    // disableEditSubTableBtn(){//編集 (edit subtable)
    //   if(this.loadBy == 'fk_id' ){
    //     return this.hideForApplicant 
    //   }
    //   return this.approvalStatus == "申請中"
    // },
    // disableCopyMainBtn(){ //コピー
    //   return false; // There is no condition to hide Copy
    // },
    // disableApplicationBtn(){ //申請/Application
    //   return this.approvalStatus != "下書中";
    // },
    // hideForApplicant(){
    //  if(this.loadBy != 'fk_id' ){
    //     return false
    //   }
    //   if(typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true)
    //   {
    //     return false;
    //   }
    //   else
    //   {//                                               user is the applicant                                     and            user is not the next approver the  hide
    //     return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == Vue.localStorage.get("userID") && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != Vue.localStorage.get("userID");
    //   }
    // },
    // hideEditMainBtn(){// 編集 (edit main)
    //   return this.hideForApplicant
    // },
    // hideNewToSubTableBtn(){// 新規 (new to sub-table)
    //   return this.hideForApplicant
    // },
    // hideEditSubTableBtn(){//編集 (edit subtable)
    //   return this.hideForApplicant
    // },
    // hideCopyMainBtn(){ //コピー
    //   return this.loadBy == 'fk_id' || this.is_new == true;
    // },
    // hideApplicationBtn(){ //申請/Application
    //   return this.loadBy == 'fk_id';
    // },
    // hideApplyConfirmationBtn(){ //確認/Confirmation
    //   if(this.loadBy != 'fk_id'){
    //     return true
    //   }
    //   return this.hideForApplicant;
    // },
    // hideApplyRejectBtn(){ //差戻/Reject
    //   //this.loadBy == 'fk_id'
    //   return this.loadBy != 'fk_id'
    // },
    // // About to hide or show the buttons end
    // Deadline_Alert:{// FIXME: This fields are not goog, it is used as copy and paster, but there are a log or unecessary code
    //   get(){
    //     if(this.local_status === false){
    //       return this.$store.state[this.stateCurrentEditing]["deadline_alert"] || "";
    //     }else{
    //       return this.local_status;
    //     }
    //    },
    //   set(v){
    //    this.$store.state[this.stateCurrentRow]["deadline_alert"] = this.local_status = v;
    //    this.$store.state[this.stateCurrentEditing]["deadline_alert"] = this.local_status = v;
    //    }
    // },
    // Comprehensive_contract:{
    //   get(){
    //     if(this.local_status === false){
    //       return this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] || "";
    //     }else{
    //       return this.local_status;
    //     }
    //    },
    //   set(v){
    //    this.$store.state[this.stateCurrentRow]["comprehensive_contract"] = this.local_status = v;
    //    this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] = this.local_status = v;
    //    }
    // },
    // Downgrade:{
    //   get(){
    //     if(this.local_status === false){
    //       return this.$store.state[this.stateCurrentEditing]["downgrade"] || "";
    //     }else{
    //       return this.local_status;
    //     }
    //    },
    //   set(v){
    //    this.$store.state[this.stateCurrentRow]["downgrade"] = this.local_status = v;
    //    this.$store.state[this.stateCurrentEditing]["downgrade"] = this.local_status = v;
    //    }
    // },
    // Status:{
    //   get(){
    //     if(this.local_status === false){
    //       return this.$store.state[this.stateCurrentRow]["status"] || "";
    //     }else{
    //       return this.local_status;
    //     }
    //   },
    //   set(v){
    //     this.$store.state[this.stateCurrentRow]["status"] = this.local_status = v;
    //     this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
    //   }
    // },
    // StatusOptions(){
    //   return fields.status.options;
    // },

    // subTableDeviceEmbeddedInformationStyle(){
    //   if(this.saveEditClicked || this.is_new == false){
    //     return "";
    //   }else{
    //     return "opacity: 0.5;";
    //   }
    // },
    // saveEditClicked:{
    //   get(){
    //     return this.save_edit_cliqued;
    //   },
    //   set(v){
    //     this.save_edit_cliqued = v;
    //   }
    // },
    // approvalHistoryId:{
    //   get(){
    //     return this.approval_history_id;
    //   },
    //   set(v){
    //     this.approval_history_id = v;
    //   }
    // },
    // approvalHistoryTorokuNumber:{
    //   get(){
    //     return this.approval_history_toroku_number;
    //   },
    //   set(v){
    //     this.approval_history_toroku_number = v;
    //   }
    // },
    // isAdminSavingApplication (){
    //   return this.isAdmin && this.loadBy == 'fk_id';
    // },
    // showFieldchangedStyle (){
    //   return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"])
    // },
    // approvalStatus(){
    //   return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
    // },
    // allowEditjurisdictionSystem(){
    //   return this.$store.state [this.stateCurrentRow] ["jurisdiction_classification"]!= "IT所管システム";
    // },
    // aprovalId:{
    //   get(){
    //     return this.aproval_id;
    //   },
    //   set(v){
    //     this.aproval_id = v;
    //   }
    // },
    // approvalStatus(){
    //   return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
    // },
    // certificateManagementNumber(){
    //   return this.$store.state[this.stateCurrentRow]["certificate_management_number"]
    // },

    // certificateSeqId(){
    //   return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"]||this.localSeqId);
    // },
    // deviceControlNumber(){
    //   return this.$store.state[this.stateCurrentRow]["device_control_number"]
    // },
    // registrationDate(){
    //   return  utils.format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    // },
    // fieldList() {
    //   return fields;
    // },
    // typeList() {
    //   return filed_types;
    // },
    // formFields() {
    //   return {
    //     col1:[
    //       utils.extend(fields.certificate_management_number, {disabled: true , read_only:true}),
    //       utils.extend(fields.company, {}),
    //       utils.extend(fields.licensed_department, {}),
    //       utils.extend(fields.license_jurisdiction_team, {}),
    //       utils.extend(fields.jurisdiction_classification, {
    //          on_set_value:(data) =>{
    //           setTimeout(() => {
    //             bus.$emit("upd_license_jurisdiction_system",{val: data == "IT所管システム"})
    //           }, 100);
    //           setTimeout(() => {
    //             bus.$emit("upd_license_jurisdiction_system_it",{val: data == "EUC・その他"})
    //           }, 110);
    //         }
    //       }),
    //       utils.extend(fields.license_jurisdiction_system, {
    //         disabled: false,
    //         required: true,
    //         field_style: " width: 100%;display: block;" ,
    //         listen_for: [
    //           {
    //             name: "upd_license_jurisdiction_system_it",
    //             mode: "disable_and_clean_if_value",
    //             disable_if_value: true
    //           }
    //         ],
    //       }),
    //       utils.extend(fields.equipment_in_charge_system, {
    //         disabled: false,
    //         required: true,
    //         field_style: " width: 100%;display: block;" ,
    //         listen_for: [
    //           {
    //             name: "upd_license_jurisdiction_system",
    //             mode: "disable_and_clean_if_value",
    //             disable_if_value: true
    //           }
    //         ],
    //       }),

    //       utils.extend(fields.license_certificate_type, {
    //         disabled: true,
    //         required: true,
    //         field_style: " width: 75%;display: inline;" ,
    //         buttons: [
    //              {
    //               btn_style:"width:20%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 2px;background: #43c9de;border-color:#43c9de;",
    //               type:"callback",
    //               callback:(b)=>{
    //                 this.openFileModal()
    //             },
    //               label:"PDF"
    //            }
    //          ]
    //        }),
    //       utils.extend(fields.certificate_individual_number, {}),
    //       utils.extend(fields.maker, {}),
    //     ],
    //     col2:[
    //       utils.extend(fields.applicant_name, {}),
    //       utils.extend(fields.management_person_name, {}),
    //       utils.extend(fields.comprehensive_contract, {}),
    //       utils.extend(fields.sales_company, {}),
    //     ],
    //     col3:[
    //       utils.extend(fields.downgrade, {}),
    //       utils.extend(fields.deadline_alert, {}),
    //       utils.extend(fields.expiration_date, {}),
    //       utils.extend(fields.maintenance_deadline, {}),
    //     ],
    //     col2b:[
    //       utils.extend(fields.remark, {}),
    //       utils.extend(fields.other_items_by_manufacturer, {}),
    //     ],
    //   }
    // },
    // loadBy(){
    //   return this.$route.meta.load_by;
    // }
  },
  methods: {
    // onDelete(){
    //   bus.$emit("deleteCertificateInformationDetailModal",{
    //     title: "削除",
    //     message: "証書情報の削除をしますがよろしいでしょうか?",
    //     yes_label: "削除",
    //     no_label: "キャンセル",
    //     yes_color:"danger",
    //     no_color:"info",
    //     model_height:"50"
    //   });
    // },
    // onConfirmDelete(mode){
    //   if(mode == "yes"){
    //     this.commonDelete(this);
    //   }
    // },
    // subTableSaved(){
    //   this.onDeviceEmbeddedInformationAddCheckConfirm("yes");
    // },
    // showHistory(){
    //    bus.$emit("showCertificateInformationlogHistoryModal",{
    //     fk_tab:constants.TABLE_ID.CERTIFICATE_INFORMATION,
    //     fk_id:this.localSeqId,
    //   });
    // },
    // onConfirmExecuteProcessConfirmation(){
    //   var cmn = this.certificateManagementNumber;
    //   if(typeof cmn == undefined || cmn == null || cmn == false || cmn.length == 0){
    //     cmn  = "BY_SEQ_ID::" + this.localSeqId;
    //   }
    //   bus.$emit("certificateApplicationConfimationModal",{
    //     application_mode:"certificate",
    //     ref_id:cmn,
    //     modal_is_read_only:true,
    //     seq_id:this.localSeqId,
    //     approval_history_id : this.approvalHistoryId || false,
    //     approval_history_toroku_number : this.approvalHistoryTorokuNumber || false
    //   });
    // },
    // cloneRecord(){
    //   return this.$router.push({ name: "page_0060_redirect", params: {
    //     url:"/certificate_information/clone/" + this.localSeqId,
    //     message:"コピー ...",
    //     wait:50
    //   } });
    // },
    // processApprovalApprove(){
    //    return this.processApproval('approve');
    // },
    // processApprovalCancelBack(mode){
    //   if(mode == "yes"){
    //     console.log("processApprovalCancelBack",mode) 
    //   　 this.processApproval('cancel');
    //      this.local_status = false;
    //   }
    // },
    // openFileModal(){
    //   bus.$emit("showFileModal2",{fk_id:this.certificateSeqId});
    // },
    // processFieldStyle(store_key_name,last_changed_fields){
    //   if(Array.isArray(last_changed_fields)){
    //     last_changed_fields.forEach(e=>{
    //     })
    //   }else{
    //   }
    //   this.$store.state[store_key_name] = {};
    //   if(last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0 ){
    //     last_changed_fields.forEach(f=>{
    //       if(this.showFieldchangedStyle){
    //         this.$store.state[store_key_name][f] = ";color:red;"
    //       }
    //     });
    //   }
    // },
    // processApproval(approve_mode){
    //   var changes = {
    //     seq_id:this.aprovalId,
    //     update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
    //   }
    //   this.$ajax.post('/approval_history/prepare_to_approve/' + this.aprovalId, {changes,approve_mode:approve_mode}, (err, result) => {
    //       if(err){
    //         this.$notify({
    //           title: 'データの承認に失敗しました。',
    //           text: err,
    //           type: 'error',
    //           duration: 10000
    //         });
    //       }else{
    //         bus.$emit("notificationAftercancel",{
    //           message: "",
    //           title: (approve_mode == 'approve') ? "申請を確認しました。":"申請が差戻されました。",
    //           yes_label: "",
    //           no_label: "OK",
    //           yes_color:"",
    //           no_color:"",
    //           model_height:"50"
    //         });

    //       }
    //     })
    // },
    // onDeviceEmbeddedInformationAddCheckConfirm(mode){
    //   if(mode == "yes"){
    //     console.log("onDeviceEmbeddedInformationAddCheckConfirm",mode)
    //     this.read_only = false;
    //     this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
    //     this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err,saved_data)=>{
    //       if(err){
    //         //commonSaveInfo already show the error, can ignore it
    //       }else{
    //         if(this.is_new == true){
    //           this.saveEditClicked = true;
    //           this.localSeqId = this.certificateSeqId;
    //         }
    //         if(typeof this.$store.state[this.stateCurrentEditing]["certificate_management_number"] != "undefined"){
    //           bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.certificateSeqId});
    //         }
    //         if(this.is_new){
    //           if(this.$store.state[this.stateCurrentRow].seq_id != Number.MAX_SAFE_INTEGER && this.$store.state[this.stateCurrentRow].seq_id> 0){
    //             bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.$store.state[this.stateCurrentRow].seq_id});
    //           }else if (this.localSeqId != Number.MAX_SAFE_INTEGER && this.localSeqId > 0){
    //             bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.localSeqId});
    //           }
    //         }
    //         bus.$emit("notificationAfterSave",{
    //           message: "",
    //           title: "登録情報を下書きに保存しました。",
    //           yes_label: "",
    //           no_label: "OK",
    //           yes_color:"",
    //           no_color:"",
    //           model_height:"50"
    //         });
    //       }
    //     });
    //   }
    // },
    // onDeviceEmbeddedInformationUpAddCheckConfirm(mode){
    //   if(mode == "yes"){
    //     console.log("onDeviceEmbeddedInformationUpAddCheckConfirm",mode)
    //     this.read_only = false;
    //     this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err)=>{
    //       if(err){
    //         //commonSaveInfo already show the error, can ignore it
    //       }else{
    //         if(typeof this.$store.state[this.stateCurrentEditing]["certificate_management_number"] != "undefined"){
    //           bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.certificateSeqId});
    //         }


    //         bus.$emit("notificationAfterSave",{
    //           message: "",
    //           title: "登録情報を上書保存しました。",
    //           yes_label: "",
    //           no_label: "OK",
    //           yes_color:"",
    //           no_color:"",
    //           model_height:"50"
    //         });
    //       }
    //     });
    //   }
    // },
    // afterTheNotificationAfterSave(mode){
    //   if(mode == "no" || mode == "yes"){
    
    //     return this.$router.push("/certificate_information/" + this.localSeqId );
    //     // if(this.is_new == true){
    //     //   this.showAssociatedDevice = false;
    //     //   setTimeout(()=>{
    //     //     this.showAssociatedDevice = true;
    //     //   },100)
    //     // }
    //     // This is another alternative, but have some colacteral effects that is possible swe should avoid.
    //     // return this.$router.push({name:"page_0092_reload",params:{return_to:"/certificate_information/" + this.localSeqId}})
    //   }
    // },
    // afterTheNotificationAftercancel(mode){
    //   if(mode == "no"){
    //     setTimeout(()=>{
    //       return this.$router.push("/approval_history");
    //     },600)
    //     console.log("afterTheNotificationAftercancel");
    //   }
    // },
    // onSave(){
    //   this.read_only = false;
    //   this.commonSaveInfo(this,this.api_name, {} );
    // },
    // btnCancel() {
    //   this.commonValidateFieldsClear(this,()=>{})
    //   this.cancelCurrentSelection(true);
    //   this.local_status = false;
    // },
    // onEdit(){
    //   mdebug("onEdit")
    //   this.commonOnEdit();
    // },
    // onConfirmExecuteProcess(){
    //   bus.$emit("certificateApplicationConfimationModal",{
    //     application_mode:"certificate",
    //     ref_id:this.certificateManagementNumber,
    //     // approval_status:this.approvalStatus,
    //     seq_id:this.localSeqId
    //   });
    // },
    // backToList(){
    //   if(this.loadBy == "fk_id"){
    //     return this.$router.push({ name: "page_0050_approval_history_tabs", params: {} });
    //   }else{
    //     return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    //   }
    // },
    // onLocalSaveDevEmbedded(){
    //   this.commonValidateFields(this,{},(error_found)=>{
    //     if(error_found != false){
    //       return;
    //     }
    //     if(this.is_new == false){
    //       this.saveEditClicked = true;
    //     }
    //     console.log("onLocalSave")
    //     bus.$emit("confirmDeviceEmbeddedInformationAddCheck",{
    //       message: "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※状態が承認済のものは下書中になります。 </span>",
    //       title: "登録情報を下書保存します。",
    //       yes_label: "下書保存",
    //       no_label: "戻る",
    //       yes_color:"primary",
    //       no_color:"",
    //       model_height:"50",
    //       model_width: "350px"
    //     });
    //   });
    // },
    // onLocalUpSaveDevEmbedded(){
    //   console.log("onLocalSave")
    //   bus.$emit("confirmDeviceEmbeddedInformationUpAddCheck",{
    //     message: "よろしいですか？",
    //     title: "登録情報を上書保存します。",
    //     yes_label: "上書保存",
    //     no_label: "戻る",
    //     yes_color:"primary",
    //     no_color:"",
    //     model_height:"50"
    //   });
    // },
    // processApprovalCancel(){
    //   console.log("processApprovalCancel")
    //   bus.$emit("confirmDeviceEmbeddedInformationAddcancel",{
    //     message: "よろしいですか？",
    //     title: "申請を差戻します。",
    //     yes_label: "差戻",
    //     no_label: "戻る",
    //     yes_color:"primary",
    //     no_color:"",
    //     model_height:"50"
    //   });
    // },
    // onEdit(){
    //   mdebug("onEdit")
    //   this.commonOnEdit();
    // },
    // prepareCompanySelection(companies, department_and_team, company_field, department_field,team_field,company_field_name,department_field_name){
    //   var selected_company = false;
    //   var selected_department = false
    //   company_field.page_controller_setup({
    //     on_select:(_selected_company)=>{
    //       selected_company = _selected_company;
    //       if(selected_company==""){
    //         department_field.page_controller_msg({cmd:"disable"})
    //         team_field.page_controller_msg({cmd:"disable"})
    //       }else{
    //         var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
    //         departments.unshift("")
    //         department_field.page_controller_msg({cmd:"enable"})
    //         department_field.page_controller_msg({cmd:"set_value",val:""})
    //         team_field.page_controller_msg({cmd:"set_value",val:""})
    //         team_field.page_controller_msg({cmd:"disable"})
    //         department_field.page_controller_msg({cmd:"set_options",options:departments, reset:true})
    //       }
    //     }
    //   })
    //   department_field.page_controller_setup({
    //     on_select:(_selected_department)=>{
    //       selected_department = _selected_department;
    //       if(selected_department == ""){
    //         team_field.page_controller_msg({cmd:"disable"})
    //         team_field.page_controller_msg({cmd:"set_value",val:""})
    //       }else{
    //         var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company && d.department == selected_department})||[],"team")||[]);
    //         teams.unshift("");
    //         team_field.page_controller_msg({cmd:"enable"})
    //         team_field.page_controller_msg({cmd:"set_options",options:teams, reset:true})
    //       }
    //     }
    //   })
    //   company_field.page_controller_msg({cmd:"set_options",options: _.clone(companies)})
    //   company_field.page_controller_msg({cmd:"enable"})
    //   department_field.page_controller_msg({cmd:"disable"})
    //   team_field.page_controller_msg({cmd:"disable"})
    //   setTimeout(() => {
    //     department_field.page_controller_msg({cmd:"enable_if_data"})
    //     team_field.page_controller_msg({cmd:"enable_if_data"})
    //     selected_company = this.$store.state[this.stateCurrentRow][company_field.id]
    //     selected_department = this.$store.state[this.stateCurrentRow][department_field.id]
    //     if(selected_company && selected_company.length > 0){
    //       var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
    //       department_field.page_controller_msg({cmd:"set_options",options:departments, reset:false})
    //       if(selected_department && selected_department.length > 0){
    //         var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company &&  d.department == selected_department})||[],"team")||[]);
    //         team_field.page_controller_msg({cmd:"set_options",options:teams, reset:false})
    //       }
    //     }
    //   }, (this.is_new)?100:500);
    // }
  },
  mounted() {
    // if(true){
    //   var temp_fields = this.installedFieldList;
    //   // Load the companies
    //   this.$ajax.post_cached_queued('/master_company/list_company_name' , {}, (err, _companies) => {
    //     if(err){
    //       this.$notify({
    //           title: '所管会社のデータが読込めませんでした。',
    //           text: err,
    //           type: 'error',
    //           duration: 10000
    //         });
    //       return ;
    //     }
    //     var companies = [""]
    //     _companies.forEach(c=>{
    //       companies.push(c.val)
    //     })
    //     // Load the departments and teams
    //     this.$ajax.post_cached_queued('/master_belongs/list_team_and_department' , {}, (err, department_and_team) => {
    //       if(err){
    //         this.$notify({
    //             title: '部署・チームのデータの読込に失敗しました。',
    //             text: err,
    //             type: 'error',
    //             duration: 10000
    //           });
    //         return ;
    //       }
    //       this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.licensed_department,temp_fields.license_jurisdiction_team,"company","department")
    //       if(this.$route.params.seq_id == "new"){
    //         var default_company = Vue.localStorage.get(temp_fields.company.default_from_local_storage);
    //         if(default_company != constants.COMPANY.ALL){
    //           setTimeout(() => {
    //             var default_deparment = Vue.localStorage.get(temp_fields.licensed_department.default_from_local_storage);
    //           var default_team = Vue.localStorage.get(temp_fields.license_jurisdiction_team.default_from_local_storage);
    //           temp_fields.company.page_controller_msg({cmd:"set_value",val:default_company})
    //           temp_fields.licensed_department.page_controller_msg({cmd:"set_value",val:default_deparment})
    //           temp_fields.license_jurisdiction_team.page_controller_msg({cmd:"set_value",val:default_team})
    //           }, (this.is_new)?300:1000);
    //         }
    //       }
    //     })
    //   })
    // }
    // mdebug("page_0040_certificate_information_detail mounting");
    // if(this.loadBy == "certificate_information_number"){ // link_from_device_embedded_information_to_certificate_information_number step3
    //   var certificate_information_number = this.$route.params.certificate_information_number;
    //  this.$ajax.post('/' + this.api_name + '/get_by_ref_id/' + certificate_information_number,  {ref_id:certificate_information_number}, (err, result) => {
    //     if(err){
    //       this.$notify({
    //         title: 'データの読込に失敗しました。',
    //         text: err,
    //         type: 'error',
    //         duration: 10000
    //       });
    //     }
    //     this.localSeqId = result.data.seq_id;
    //     this.$store.state[this.stateCurrentRow] = result.data;
    //     if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
    //       isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
    //       ){
    //         this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
    //         this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number
    //         if(this.approvalHistoryId == -200){
    //           this.approvalHistoryTorokuNumber
    //         }
    //       }

    //     bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.localSeqId});

    //     this.commonSetStyleForChangedFields(result.data);
    //     mdebug("LOAD DATA",{err, result});
    //   })
    // } else if (this.loadBy == "fk_id"){
    //   this.is_new = false;
    //     this.localSeqId = this.$route.params.fk_id;
    //     this.aprovalId = this.$route.params.approval_id;
    //     this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.fk_id,  {fk_id: this.$route.params.fk_id}, (err, result) => {
    //       if(err){
    //         this.$notify({
    //           title: 'データの読込に失敗しました。',
    //           text: err,
    //           type: 'error',
    //           duration: 10000
    //         });
    //       }
    //       this.localSeqId = result.data.seq_id;
    //       this.$store.state[this.stateCurrentRow] = result.data;
    //       if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
    //       isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
    //       ){
    //         this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
    //         this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number
    //         if(this.approvalHistoryId == -200){
    //           this.approvalHistoryTorokuNumber
    //         }
    //       }

    //       this.commonSetStyleForChangedFields(result.data);
    //       bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.localSeqId});
    //       mdebug("LOAD DATA",{err, result});
    //     })
    // }else if(this.loadBy == "clone"){
    //     this.is_new = true;
    //     this.localSeqId = Number.MAX_SAFE_INTEGER
    //     this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.seq_id, {}, (err, result) => {
    //       if(err){
    //         this.$notify({
    //           title: 'データの読込に失敗しました。',
    //           text: err,
    //           type: 'error',
    //           duration: 10000
    //         });
    //       }
    //       // result.data.seq_id = Number.MAX_SAFE_INTEGER;
    //       // result.data.device_control_number = "";
    //       this.$store.state[this.stateCurrentRow] = {};
    //       this.$store.state[this.stateCurrentEditing] = {};
    //       Object.keys(result.data).forEach(k =>{
    //         var value = result.data[k];
    //         if(k == "seq_id"){
    //           this.$store.state[this.stateCurrentRow][k] = Number.MAX_SAFE_INTEGER;
    //           // this.$store.state[this.stateCurrentEditing][k] = Number.MAX_SAFE_INTEGER;
    //         }else if(k == "certificate_management_number"){
    //           this.$store.state[this.stateCurrentRow][k] = "";
    //           this.$store.state[this.stateCurrentEditing][k] = "";
    //         }else if(k == "approval_status_flag"){
    //           this.$store.state[this.stateCurrentRow][k] = 0;
    //           this.$store.state[this.stateCurrentEditing][k] = 0;
    //         }else{
    //           this.$store.state[this.stateCurrentRow][k] = value;
    //           this.$store.state[this.stateCurrentEditing][k] = value;
    //         }

    //       })
    //       this.Status = "使用中";  


    //       this.commonSetStyleForChangedFields(result.data);
    //       setTimeout(() => {
    //         this.$store.state[this.stateIsEditingNew] = true;
    //         this.read_only = false;
    //         this.is_new = true;
    //       }, 300);
    //       this.commonEditDeleteCmdHandler(this);

    //     })
    // }else{
    //   this.commonLoadRecord({},(err,result)=>{
    //     bus.$emit("reloadSubTableCertificateInformation",{fk_id:this.$route.params.seq_id});
    //       if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
    //       isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
    //       ){
    //         this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
    //         this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number
    //         if(this.approvalHistoryId == -200){
    //           this.approvalHistoryTorokuNumber
    //         }
    //       }
    //     if(this.$route.params.seq_id == "new"){
    //         this.Deadline_Alert = "無";
    //         this.Comprehensive_contract = "無";
    //         this.Downgrade = "無";
    //         this.Status = "使用中";
    //     }
    //     this.commonEditDeleteCmdHandler(this);
    //   })
    // }
  },
  beforeDestroy() {
    // var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")] = {};
  },
  beforeMount() {
  }
};

</script>
<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information_detail.vue?251b309c